import React, { useState, useEffect, useContext, useRef } from "react";
import { Form, Row, Col, Button, Table, Badge, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faEraser } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "react-bootstrap";

import { GET_LIST_RELATORIO_USUARIO } from "../../../services/Relatorio";
import { GET_LIST_USUARIO } from "services/Usuario";

import { Context } from "context/AuthContext";


import "../ErrosPorQuestao/styles.scss";
import { set } from "jodit/esm/core/helpers";

const ContentRelatorioUsuario = () => {
  const valorInicial = {
    usuarioId: 0,
    nome: "",
    email: "",
    totalErros: 0,
    PageNumber: 1,
    PageSize: 25,
  };

  const [filtro, setFiltro] = useState(valorInicial);
  const [filtroLimpo, setFiltroLimpo] = useState(false);
  const [usuariosRelatorio, setUsuariosRelatorio] = useState([]);
  const [loading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([
    { label: "Selecione um usuário", value: "", id: "" },
  ]);

  // UseRef para evitar rolagem para o topo
  const tabelaRef = useRef(null);

  useEffect(() => {
    // Carregar dados iniciais
    loadData();
  }, []);

  const loadData = async () => {

    try {
      setLoading(true);
      // Executa ambas as requisições simultaneamente
      const [relatorioData, usuarioData] = await Promise.all([
        handleGetRelatorioUsuario(),
      ]);

      if (relatorioData) {
        setUsuariosRelatorio(relatorioData.value);
      }
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleGetRelatorioUsuario = async () => {
    return await GET_LIST_RELATORIO_USUARIO(filtro);
  };


  const handleSaveFilter = async () => {
    setLoading(true);
    const data = await GET_LIST_RELATORIO_USUARIO(filtro);

    if (data) {
      setUsuariosRelatorio(data.value);
    }
    setLoading(false);
  };

  const handleClearFilter = async () => {
    setFiltro(valorInicial);
    setFiltroLimpo(true);
    setLoading(true);
    const data = await GET_LIST_RELATORIO_USUARIO(valorInicial);

    if (data) {
      setUsuariosRelatorio(data.value);
    }
    setLoading(false);
  };

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltro({ ...filtro, [name]: value });
  };

  return (
    <React.Fragment>
      <div className=" relatorio-container-questoes container-fluid" ref={tabelaRef}>
        <div className="relatorio-content-wrapper">
          <div className="relatorio-content">
            <Form className=" ms-3 p-2">
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className="mb-3">
                    Nome
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="nome"
                    type="text"
                    value={filtro.nome}
                    onChange={handleFiltroChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="col-md-8">
                <Col sm="3">
                  <Form.Label column className=" mb-3">
                    Email
                  </Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    name="email"
                    value={filtro.email}
                    type="text"
                    onChange={handleFiltroChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="2"></Col>
                <Col sm="8" className="d-flex justify-content-start">
                  <Button
                    className="btn-filtro-relatorio me-3"
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSaveFilter();
                    }}>
                    <FontAwesomeIcon icon={faSearch} className="btn-icon" />
                    Filtrar
                  </Button>
                  <Button
                    className="btn-filtro-relatorio"
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClearFilter();
                    }}>
                    <FontAwesomeIcon icon={faEraser} className="btn-icon" />
                    Limpar filtro
                  </Button>
                </Col>
              </Form.Group>
            </Form>
            <hr />
            {loading ? (
              <div className="loader-gif-container">
                <Spinner animation="border" role="status" className="loader-spinner" />
              </div>) : (
              <Table responsive="sm" bsPrefix="relatorio-table">
                <thead>
                  <tr>
                    <th>Usuário</th>
                    <th>Email</th>
                    <th>Total de questões respondidas</th>
                    <th>Porcentagem de Acertos</th>
                  </tr>
                </thead>
                <tbody>
                  {usuariosRelatorio.length > 0 ? (
                    usuariosRelatorio.map((usuariosRelatorio, index) => (
                      <tr key={index}>
                        <td>
                          {usuariosRelatorio.nome}
                        </td>
                        <td>
                          {usuariosRelatorio.email}
                        </td>
                        <td>
                          {usuariosRelatorio.totalQuestoesUsuario}
                        </td>
                        <td>{usuariosRelatorio.porcentagemAcertos + "%"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        Nenhuma informação encontrada
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentRelatorioUsuario;
